//BookShelfListComponents.jsx
// TODO - BookImage to be served from BookMaster
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import Tooltip from '../../components/utils/Tooltip';

import OrderFlowMLMButtonWithCount from './OrderFlowMLMButtonWithCount';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faBookOpen, faGifts, faUserFriends, faUserPlus, faUserTie, faUsers } from '@fortawesome/free-solid-svg-icons';
import './OrderFlowMyProductsList.css';
import './OrderFlowTables.css';

import OrderFlowMultiLevelReferralTable from './OrderFlowMultiLevelReferralTable';

// import { 
//   Book1Image, Book2Image, RCABookImage, EcommerceImage, ManufacturingImage, 
//   GeneralImage, NoBookImage, AartiImage, AchheDinImage, BhagwadGeetaImage, BibleImage, 
//   BiryaniImage, CandlestickImage, ChildFruitsImage, Covid19Image, DiwaliImage, 
//   EconomicsFunImage, GKImage, GoodTouchBadTouchImage, GooHabitBadHabitImage, GratitudeImage, 
//   GSTICSEClass10Image, GSTProfessionalImage, GuruGranthImage, HanumanjiImage, ICSEMathsImage, 
//   IndiaNationalAnthemImage, IndianFlagImage, IndianMediaImage, IPLImage, KotaFactorImage, KuranImage, 
//   LoveImage, MantraImage, MathFormulaImage, MomAndBabyImage, NoImageImage, PanchtantraImage, PTImage, 
//   PujaImage, PurplePowerImage, ReboundImage, ReelsImage, RussiaUkrainWarImage, SanatanImage, SelfishImage, 
//   SundarkandImage, SuryatilakImage, T20Image, UddhavGeetaImage, TouchHumanBodyMaleAnatomyImage, 
//   ChildColorsImage, ChildNumbersEngImage, ChildAlphabetImage, ChildShapesSizesImage, 
//   ChildBirdsImage, ChildVegetableImage, ChildFlowersImage, KidMobile1Image, 
//   KidMobile2Image, ChildWorldAroundUsImage, ChildKnowYourBodyImage, ChildFarmPetAnimalsImage, 
//   ChildUnderwaterAnimalsImage, ChildMySchoolImage, ChildJobsPeopleDoImage, 
//   ChildWildAnimalsImage, ChildThingsAtHomeImage, ChildFeelingsEmotionsMannersImage, 
//   ChildFirstWordsImage, ChildVehiclesImage, ChildFruitSet2Image, ChildPlantImage, ChildHinduGodImage, 
//   ChildTreesImage, ChildFoodImage, ChildOppositeImage, Think5WhysCollection1Image, 
//   Think5WhysCollection2Image, ShareMarketWealthMantraCollectionImage, PurplePowerCollectionImage, 
//   SmartMoneyConceptImage, VOGABGymImage, PTElementsDetailsImage, PTElementsFlashImage, 
//   PTTemplatesImage, PTStoryImage } from './OrderFlowImageImports';
// import adImage from '../../assets/pageimages/bookshelflistad.webp';

const BookShelfListComponent = () => {
    const authState = useSelector(state => state.authReducer);
    const navigate = useNavigate();

    const [userId, setUserId] = useState(authState.user._id);
    const [ownerId, setownerId] = useState(authState.user._id);
    const [ownerName, setownerName] = useState(authState.user.name);
    const [myUserCode, setMyUserCode] = useState(authState.user.think5whyscode);
    const [userLevel, setUserLevel] = useState(0);
    const [atLevel, setAtLevel] = useState(0);

    const [bookId, setBookId] = useState(null);
    const [myBooks, setMyBooks] = useState([]);
    const [numberOfBooks, setNumberOfBooks] = useState([]);
    const [readLogs, setReadLogs] = useState([]);
    const [fetchData, { loading }] = useFetch();
    const [selectedBookId, setSelectedBookId] = useState(null);
    const [selectedReferralBookId, setSelectedReferralBookId] = useState(null);

    const [selectedLog, setSelectedLog] = useState(null);
    const [speechPrefClicked, setSpeechPrefClicked] = useState(false);
    const [speechPref, setSpeechPref] = useState(false);
    const [flyOnTheWall, setFlyOnTheWall] = useState(false);
    const [expandedDates, setExpandedDates] = useState([]);
    const [myReferralsList, setMyReferralsList] = useState([]);
    const [selectedLevel, setSelectedLevel] = useState(0);
    const [myReferralsCount, setMyReferralsCount] = useState(0);
    const [downTheLineGetAllCountClicked, setDownTheLineGetAllCountClicked] = useState(false);
    const [downTheLineGetYTDCountClicked, setDownTheLineGetYTDCountClicked] = useState(false);
    const [downTheLineGetMTDCountClicked, setDownTheLineGetMTDCountClicked] = useState(false);
    const [downTheLineGetLastSevenDaysCountClicked, setDownTheLineGetLastSevenDaysCountClicked] = useState(false);
    const [downTheLineGetTodayCountClicked, setDownTheLineGetTodayCountClicked] = useState(false);
    const [downTheLineGetCustomCountClicked, setDownTheLineGetCustomCountClicked] = useState(false);


    const [downTheLineGetCount, setDownTheLineGetCount] = useState({
        l1: { count: 0, totalCom: 0 },
        l2: { count: 0, totalCom: 0 },
        l3: { count: 0, totalCom: 0 },
        l4: { count: 0, totalCom: 0 },
        l5: { count: 0, totalCom: 0 },
        l6: { count: 0, totalCom: 0 },
        l7: { count: 0, totalCom: 0 },
        l8: { count: 0, totalCom: 0 }
    });
    

    const [showTree, setShowTree] = useState(false);

    const [tree, setTree] = useState(null);
    const [totalUsers, setTotalUsers] = useState(0);
    const [showTable, setShowTable] = useState(false);

    const [postCommentClicked, setPostCommentClicked] = useState(false);
    const [postedComment, setPostedComment] = useState(false);
    const [postedCommentMsg, setPostedCommentMsg] = useState("");
    const [postMyCommentClicked, setPostMyCommentClicked] = useState(false);
    const [commentListFetched, setCommentListFetched] = useState(false);
    const [commentData, setCommentData] = useState([]);
    const [currentPageNumber, setCurrentPageNumber] = useState(1);
    const [bookIdForComment, setBookIdForComment] = useState("");
    const [bookTitleForComment, setBookTitleForComment] = useState("");
    const [bookUserIdForComment, setBookUserIdForComment] = useState("");
    const [userCommentTitle, setUserCommentTitle] = useState("");
    const [userCommentDetails, setUserCommentDetails] = useState("");
    const [isVisibleToAllChecked, setIsVisibleToAllChecked] = useState(false);
    const [postToBeDisabled, setPostToBeDisabled] = useState(false);
    const [readCommentClicked, setReadCommentClicked] = useState(false);
    const [postCloseClicked, setPostCloseClicked] = useState(false);
    const [readCommentCloseClicked, setReadCommentCloseClicked] = useState(false);
    const [isImportantChecked, setIsImportantChecked] = useState(false);
    const [errors, setErrors] = useState();


    const fetchMyBooks = useCallback(() => {
        const config = {
            url: "/mybooks",
            method: "get",
            headers: { Authorization: authState.token },
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (response && Array.isArray(response.mybooks)) {
                    setMyBooks(response.mybooks);
                    setNumberOfBooks(myBooks.length);
                } else {
                    console.error("Invalid response format: Book not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching MyBooks:", error);
            });
    }, [authState.token, fetchData]);


    useEffect(() => {
        if (!authState.isLoggedIn) return;
        fetchMyBooks();
    }, [authState.isLoggedIn, fetchMyBooks]);

    const imageMap = { Book1Image, Book2Image, RCABookImage, EcommerceImage, ManufacturingImage, GeneralImage, NoBookImage, AartiImage, AchheDinImage, BhagwadGeetaImage, BibleImage, BiryaniImage, CandlestickImage, ChildFruitsImage, Covid19Image, DiwaliImage, EconomicsFunImage, GKImage, GoodTouchBadTouchImage, GooHabitBadHabitImage, GratitudeImage, GSTICSEClass10Image, GSTProfessionalImage, GuruGranthImage, HanumanjiImage, ICSEMathsImage, IndiaNationalAnthemImage, IndianFlagImage, IndianMediaImage, IPLImage, KotaFactorImage, KuranImage, LoveImage, MantraImage, MathFormulaImage, MomAndBabyImage, NoImageImage, PanchtantraImage, PTImage, PujaImage, PurplePowerImage, ReboundImage, ReelsImage, RussiaUkrainWarImage, SanatanImage, SelfishImage, SundarkandImage, SuryatilakImage, T20Image, UddhavGeetaImage, TouchHumanBodyMaleAnatomyImage, ChildColorsImage, ChildNumbersEngImage, ChildAlphabetImage, ChildShapesSizesImage, ChildBirdsImage, ChildVegetableImage, ChildFlowersImage, KidMobile1Image, KidMobile2Image, ChildVehiclesImage, ChildWorldAroundUsImage, ChildKnowYourBodyImage, ChildFarmPetAnimalsImage, ChildUnderwaterAnimalsImage, ChildMySchoolImage, ChildJobsPeopleDoImage, ChildWildAnimalsImage, ChildThingsAtHomeImage, ChildFeelingsEmotionsMannersImage, ChildFirstWordsImage, ChildFruitSet2Image, ChildPlantImage, ChildHinduGodImage, ChildTreesImage, ChildFoodImage, ChildOppositeImage, Think5WhysCollection1Image, Think5WhysCollection2Image, ShareMarketWealthMantraCollectionImage, SmartMoneyConceptImage, PurplePowerCollectionImage, VOGABGymImage, PTElementsDetailsImage, PTElementsFlashImage, PTTemplatesImage, PTStoryImage };

    const getImage = (bookImage) => {
        if (imageMap.hasOwnProperty(bookImage)) {
            return imageMap[bookImage];
        } else {
            return NoImageImage;
        }
    };

    const formatDate = (date) => {
        const jsDate = new Date(date);
        const day = jsDate.getDate().toString().padStart(2, '0');
        const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
        const year = jsDate.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const formatDateTime = (date) => {
        const options = {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hour12: false
        };
        const jsDate = new Date(date);
        const day = jsDate.getDate().toString().padStart(2, '0');
        const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
        const year = jsDate.getFullYear();
        const hours = jsDate.getHours().toString().padStart(2, '0');
        const minutes = jsDate.getMinutes().toString().padStart(2, '0');
        const seconds = jsDate.getSeconds().toString().padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };

    const formatReadTime = (milliseconds) => {
        const totalSeconds = Math.floor(milliseconds / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes}:${seconds}`;
    };

    const handleReadClick = (bookCode, bookMasterId, bookCollectionName, lastPageRead, bookPages, bookIsChildren) => {
        navigate('/readbook', { state: { bookId: bookCode, bookMasterId: bookMasterId, bookCollectionName: bookCollectionName, lastPageRead: lastPageRead, bookPages: bookPages, isChildren: bookIsChildren } });
    };

    const handleReadLogClick = (bookId) => {
        setSelectedBookId(prev => (prev === bookId ? null : bookId));
        fetchReadingLog(bookId);
    };

    useEffect(() => {
        // Fetch reading log when selected book changes
    }, [selectedBookId]);

    const handleSpeechPrefClick = (bookId) => {
        setSpeechPrefClicked(true);
        setSpeechPref(true);
    };

    const handleFlyOnTheWallClick = (bookId, bookTitle) => {
        navigate('/flyonwall/add', { state: { bookId: bookId, bookTitle: bookTitle, ownerId: ownerId, ownerName: ownerName, flyerOnTheWallId: null, flyerOnTheWallName: null } });
    };

    const handleFlyerOnTheWallListClick = (bookId, bookTitle) => {
        navigate('/flyersonthewall', { state: { bookId: bookId, bookTitle: bookTitle, ownerId: ownerId, ownerName: ownerName, fromPage: "bookShelfList" } });
    };

    const handleDcrClick = (bookId, bookTitle) => {
        navigate('/dcr/add', { state: { bookId: bookId, bookTitle: bookTitle, ownerId: ownerId, ownerName: ownerName, coReaderId: null, coReaderName: null } });
    };

    const handleDcrListClick = (bookId, bookTitle) => {
        navigate('/dcrlist', { state: { bookId: bookId, bookTitle: bookTitle, ownerId: ownerId, ownerName: ownerName, fromPage: "bookShelfList" } });
    };

    const fetchReadingLog = useCallback((bookId) => {
        setBookId(bookId);
        const config = {
            url: "/myreadinglog",
            method: "get",
            headers: { Authorization: authState.token },
            params: { bookId: bookId, userId: userId }
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                if (response && Array.isArray(response)) {
                    setReadLogs(response);
                    setSelectedLog(bookId);
                } else {
                    console.error("Invalid response format: Book reading log not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching BooksReadingLog:", error);
            });
    }, [authState.token, fetchData, userId, bookId]);

    useEffect(() => {
        fetchReadingLog(bookId);
    }, [fetchReadingLog, setReadLogs]);


    useEffect(() => {
        //
    }, [readLogs, bookId], selectedLog);

    const [showReferralsList, setShowReferralsList] = useState(false);

    const handleMyReferralsListClick = (bookId, myUserCode, userLevel) => {
        setSelectedReferralBookId(prev => (prev === bookId ? null : bookId));
        // setSelectedBookId(prev => (prev === bookId ? null : bookId));

        setShowReferralsList(!showReferralsList);
        fetchMyReferralsList(bookId, myUserCode, userLevel);
    };

    const handleMyReferralsCountClick = (bookId, myUserCode, userLevel, atLevel) => {
        fetchMyReferralsCount(bookId, myUserCode, userLevel, atLevel);
    };

    const fetchMyReferralsList = useCallback((bookId, myUserCode, userLevel) => {
        setBookId(bookId);
        setMyUserCode(myUserCode);
        setUserLevel(userLevel);
        const config = {
            url: "/mybooks/myreferralslist",
            method: "post",
            headers: { Authorization: authState.token },
            data: { bookId: bookId, advisorCode: myUserCode, userLevel: userLevel }
        };

        fetchData(config)
            .then(response => {
                // console.log("response from referral list endpoint: ", response);
                if (response && response.referralsList && Array.isArray(response.referralsList)) {
                    setMyReferralsList(response.referralsList);
                } else {
                    console.error("Invalid response format: Referral List not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching Referral List:", error);
            });
    }, [authState.token, fetchData, userId, bookId]);

    useEffect(() => {
        // fetchMyReferralsList(bookId, myUserCode);
    }, [fetchMyReferralsList, setMyReferralsList]);

    const fetchMyReferralsCount = useCallback((bookId, myUserCode, userLevel, atLevel) => {
        setBookId(bookId);
        setMyUserCode(myUserCode);
        setAtLevel(atLevel);
        const config = {
            url: "/mybooks/myreferralscount",
            method: "post",
            headers: { Authorization: authState.token },
            data: { bookId: bookId, advisorCode: myUserCode, userLevel: userLevel, atLevel: atLevel }
        };

        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("response from referral list endpoint: ", response);

                if (response) {
                    setMyReferralsCount(response.referralsCount);
                    setSelectedLevel(atLevel);
                } else {
                    console.error("Invalid response format: Referral Count not found in response");
                }
            })
            .catch(error => {
                console.error("Error fetching Referral Count:", error);
            });
    }, [authState.token, fetchData, userId, bookId, myUserCode, userLevel, atLevel]);

    useEffect(() => {
        // fetchMyReferralsCount(bookId, myUserCode, atLevel);
    }, [fetchMyReferralsCount, setMyReferralsCount]);


    useEffect(() => {
        //
    }, [myReferralsCount, bookId], myUserCode, atLevel, selectedLevel);

    const dateRangeType='A';
    const [fromDate, setFromDate] = useState(new Date().toISOString().split('T')[0]);
    const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
    const [customFromDate, setCustomFromDate] = useState(new Date().toISOString().split('T')[0]);
    const [customToDate, setCustomToDate] = useState(new Date().toISOString().split('T')[0]);

    const handleDownTheLineGetAllCount = (selectedBookId) => {
        setDownTheLineGetAllCountClicked(true);
        const fromDate = new Date().toISOString().split('T')[0];;
        const toDate = new Date().toISOString().split('T')[0];;
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'A', fromDate, toDate);
    };

    const handleDownTheLineGetYTDCount = (selectedBookId) => {
        setDownTheLineGetYTDCountClicked(true);
        // Calculate toDate (yesterday's date)
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        const toDate = yesterday.toISOString().split('T')[0]; // Example: "2024-07-10"

        const firstDateOfYear = new Date(today.getFullYear(), 0, 1); // Month is 0-based, so 0 represents January
        const fromDate = firstDateOfYear.toISOString().split('T')[0]; // Example: "2024-01-01"
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'Y', fromDate, toDate);
    };

    const handleDownTheLineGetMTDCount = (selectedBookId) => {
        setDownTheLineGetMTDCountClicked(true);
        // Calculate toDate (yesterday's date)
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        const toDate = yesterday.toISOString().split('T')[0]; // Example: "2024-07-10"

        const firstDateOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        const fromDate = firstDateOfMonth.toISOString().split('T')[0]; // Example: "2024-07-01"
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'M', fromDate, toDate);
    };

    const handleDownTheLineGetLastSevenDaysCount = (selectedBookId) => {
        setDownTheLineGetLastSevenDaysCountClicked(true);
        // Calculate toDate (yesterday's date)
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        const toDate = yesterday.toISOString().split('T')[0]; 

        // Calculate fromDate (6 days before toDate)
        const sixDaysAgo = new Date(yesterday);
        sixDaysAgo.setDate(sixDaysAgo.getDate() - 6);
        const fromDate = sixDaysAgo.toISOString().split('T')[0]; 
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'W', fromDate, toDate);
    };

    const handleDownTheLineGetTodayCount = (selectedBookId) => {
        setDownTheLineGetTodayCountClicked(true);
        const fromDate = new Date().toISOString().split('T')[0];
        const toDate = new Date().toISOString().split('T')[0];
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'T', fromDate, toDate);
    };

    const handleDownTheLineGetCustomCount = (selectedBookId) => {
        setDownTheLineGetCustomCountClicked(true);
        const fromDate = customFromDate;
        const toDate = customToDate;
        fetchDownTheLineGetCount(selectedBookId, myUserCode, userId, 'C', fromDate, toDate);
    };

    const fetchDownTheLineGetCount = useCallback((selectedBookId, myUserCode, myUserId, dateRangeType, fromDate, toDate) => {
        setBookId(selectedBookId);
        setMyUserCode(myUserCode);
        if (!selectedBookId || !myUserCode || !myUserId || !dateRangeType || !fromDate || !toDate) {
            return;
        }
        const config = {
            url: "/mlmchart/downthelinecount",
            method: "post",
            headers: { Authorization: authState.token },
            data: { 
                bookId: selectedBookId, 
                userCode: myUserCode, 
                userId: myUserId, 
                dateRangeType: dateRangeType, 
                fromDate: fromDate,
                toDate: toDate 
            }
        };
        // console.log("Request Payload:", { selectedBookId, myUserCode, myUserId, dateRangeType, fromDate, toDate }); // Log the payload
        fetchData(config, { showSuccessToast: false })
            .then(response => {
                // console.log("response from referral list endpoint: ", response);

                if (response && response.referralsCount) {
                    setDownTheLineGetCount(response.referralsCount);
                } else {
                    console.error("Invalid response format: Down The Line Referral Count not found in response");
                    setDownTheLineGetCount({
                        l1: { count: 0, totalCom: 0 },
                        l2: { count: 0, totalCom: 0 },
                        l3: { count: 0, totalCom: 0 },
                        l4: { count: 0, totalCom: 0 },
                        l5: { count: 0, totalCom: 0 },
                        l6: { count: 0, totalCom: 0 },
                        l7: { count: 0, totalCom: 0 },
                        l8: { count: 0, totalCom: 0 }
                    });
                }
            })
            .catch(error => {
                console.error("Error fetching Down The Line  Referral Count:", error);
                setDownTheLineGetCount({
                    l1: { count: 0, totalCom: 0 },
                    l2: { count: 0, totalCom: 0 },
                    l3: { count: 0, totalCom: 0 },
                    l4: { count: 0, totalCom: 0 },
                    l5: { count: 0, totalCom: 0 },
                    l6: { count: 0, totalCom: 0 },
                    l7: { count: 0, totalCom: 0 },
                    l8: { count: 0, totalCom: 0 }
                });
            });
    }, [authState.token, fetchData]);

    useEffect(() => {
            // fetchDownTheLineGetCount(bookId, myUserCode, userId, dateRangeType, fromDate, toDate); 
    }, [setDownTheLineGetCount, fetchDownTheLineGetCount]);

    const sortedBooks = myBooks.sort((a, b) => {
        const dateA = new Date(a.purchaseDate);
        const dateB = new Date(b.purchaseDate);
        return dateB - dateA;
    });


    const sortedLog = readLogs.sort((a, b) => {
        const dateA = new Date(a.dateRead);
        const dateB = new Date(b.dateRead);
        return dateB - dateA;
    });

    const toggleDateExpansion = (date) => {
        if (expandedDates.includes(date)) {
            setExpandedDates(expandedDates.filter(item => item !== date));
        } else {
            setExpandedDates([...expandedDates, date]);
        }
    };

    const logsByDate = readLogs.reduce((acc, log) => {
        const date = log.dateRead.split('T')[0];
        if (!acc[date]) {
            acc[date] = [];
        }
        acc[date].push(log);
        return acc;
    }, {});

  // Sort dates in descending order
  const sortedLogsByDate = Object.keys(logsByDate)
      .sort((a, b) => new Date(b) - new Date(a))
      .reduce((acc, date) => {
          acc[date] = logsByDate[date];
          return acc;
      }, {});

      // console.log("sortedLogsByDate ",sortedLogsByDate);

    const totalCount = Object.values(downTheLineGetCount).reduce((sum, level) => sum + level.count, 0);
    const totalCommission = Object.values(downTheLineGetCount).reduce((sum, level) => sum + parseFloat(level.totalCom), 0);

    const [showReferrals, setShowReferrals] = useState(false);

    const toggleReferralsList = () => {
      setShowReferrals(!showReferrals);
    };

  const [viewCommentClick, setViewCommentClick] = useState(false);
  const [viewCommentClickMsg, setViewCommentClickMsg] = useState('');
  const handleViewComments = (bookId, pageNumber, userId) => {
    setViewCommentClick(true);
    setViewCommentClickMsg("You can view your annotations & other's comments for this page! We will get back to you soon with this feature.");
  }

  const postComment = (bookIdForComment, bookTitleForComment, userIdForComment, pageNumber ) => {
    // console.log("I am inside postCooment()");
    setCurrentPageNumber(pageNumber);
    setBookIdForComment(bookIdForComment);
    setBookTitleForComment(bookTitleForComment);
    setBookUserIdForComment(userIdForComment);
    setUserCommentTitle("");
    setUserCommentDetails("");
    setIsImportantChecked(false);
    setIsVisibleToAllChecked(false);
    setErrors("");
    setPostedCommentMsg("");
    setPostCommentClicked(true);
    setPostCloseClicked(false);
    setPostToBeDisabled(false);
  };

  const handlePostComment = (
    commentTitle,
    commentDetails,
    isImportant,
    visibleToAll,
    selectedPageNumber,
    selectedBookId,
    selectedBookTitle, 
    selectedBookOwnerId
  ) => {
    setPostCommentClicked(true);
    setPostToBeDisabled(true);

  //   console.log("inside handlePostComment",commentTitle,
  //     commentDetails,
  //     isImportant,
  //     visibleToAll,
  //     selectedPageNumber,
  //   selectedBookId,
  //   selectedBookTitle,
  //   selectedBookOwnerId
  // );

    if (commentTitle == "") {
      setErrors("Comment title must not be blank");
      return;
    }
    if (commentDetails == "") {
      setErrors("Comment/details must not be blank");
      return;
    }
    postReadComment(
      commentTitle,
      commentDetails,
      isImportant,
      visibleToAll,
      selectedPageNumber,
      selectedBookId,
      selectedBookTitle,
      selectedBookOwnerId
    );
  };

  //Read Post Comments
  const postReadComment = useCallback(
    (
      commentTitle,
      commentDetails,
      isImportant,
      visibleToAll,
      selectedPageNumber,
      selectedBookId,
      selectedBookTitle,
      selectedBookOwnerId
    ) => {
      const config = {
        url: "/myreadingnotes",
        method: "post",
        headers: { Authorization: authState.token },
        data: {
          userId: selectedBookOwnerId,
          bookId: selectedBookId,
          bookTitle: selectedBookTitle,
          pageNumber: selectedPageNumber,
          isImportant: isImportant,
          notesTitle: commentTitle,
          notesText: commentDetails,
          notesBy: authState.user.name,
          notesByCode: authState.user.think5whyscode,
          notesType: "TXT",
          visibleToAll: visibleToAll,
          teamCode: "",
          notesPictureData: "",
          isActive: true,
          isDeleted: false,
          dateCreated: new Date(),
          notesRemarks: "",
          creatorId: authState.user._id,
        },
      };
      // console.log("BookRead Post Comments config to server: ", config);

      fetchData(config, { showSuccessToast: false })
        .then((response) => {
          // console.log("BookRead comments data posting Response:", response);
          if (response && response.status) {
            setPostedComment(true);
            setPostedCommentMsg("Comment Posted");
          } else {
            console.error("BookRead comments data posting error");
            setPostedCommentMsg("Error in Posting Your Comment. Please Retry.");
          }
        })
        .catch((error) => {
          console.error("Error in Posting Your Comment:", error);
        });
    },
    [authState.token, setPostedComment, setPostedCommentMsg]
  );

  const readComment = (selectedBookId, bookOwnerId, bookPageNumber) => {
    setReadCommentClicked(true);
    fetchReadCommentByPageNumber(selectedBookId, bookOwnerId, bookPageNumber);
    setReadCommentCloseClicked(false);
  };


  //Read Comments List
  const fetchReadCommentByPageNumber = useCallback((selectedBookId, bookOwnerId, bookPageNumber) => {
    const config = {
      url: "/myreadingnotes/notesbybookpage",
      method: "post",
      headers: { Authorization: authState.token },
      data: {
        bookId: selectedBookId,
        userId: bookOwnerId,
        pageNumber: bookPageNumber
      },
    };
    // console.log("Read Comments config to server: ", config);

    fetchData(config, { showSuccessToast: false })
      .then((response) => {
        // console.log("Read Comments Response:", response);
        if (response && response.status) {
          setCommentData(response.notes);
          // console.log("setCommentData ", response.notes); // Log response.notes
        } else {
          console.error("Read Comments data not found in response");
        }
      })
      .catch((error) => {
        console.error("Error fetching Read Comments data:", error);
      });
  }, [authState.token, fetchData]);


  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchReadCommentByPageNumber();
  }, [authState.isLoggedIn, fetchReadCommentByPageNumber]);

  const sortedCommentData = [...commentData].sort(
    (a, b) => new Date(b.dateCreated) - new Date(a.dateCreated)
  );

  const handlePostClose = () => {
    setPostCloseClicked(true);
    setPostCommentClicked(false);
    setPostToBeDisabled(true);
  };

  const handleReadCommentClose = () => {
    setReadCommentClicked(false);
    setReadCommentCloseClicked(true);
  };


  const gotoRCA = (bookIdForComment, bookTitleForComment, userIdForComment, pageNumber ) => {
    // console.log("I am inside gotoRCA()");
    navigate("/rcas/add");
  };

    return (
      <div className="book-list">
        <div className="ml-2 mr-2 page-content flex flex-col items-center justify-center">
          {/* <div className="mt-4">
            <img src={adImage} />
          </div> */}
          <div className="mt-4">
            {myBooks.length < 1 && (
              <div className="text-yellow-500 text-4xl mt-4">
                <p>Your Bookshelf is Empty!!</p>
              </div>
            )}
          </div>
        </div>

        {sortedBooks.map((book, index) => (
          <div key={book.bookCode} className="book-item">
            <div>
              {/* <h2 className="text-orange-600">Your BookShelf Book# {index+1}{' / '}{numberOfBooks}</h2> */}
              <h2 className="text-orange-600">Title - # {index + 1}</h2>
            </div>
            {book.collectionId !== null && (
              <div className="details-container">
                <h2 className="book-title text-green-700">
                  This is part of{" "}
                  <span className="text-green-700">
                    {book.collectionTitle} Collection of Books
                  </span>
                </h2>
              </div>
            )}
            {book.isCollection === true && (
              <div>
                <p className="text-orange-600 ">
                  This is a collection. You can't read a collection directly. In
                  stead read the books of this collection available in your
                  BookShelf.
                </p>
              </div>
            )}
            <div className="thumb-book-image-container">
              {/* <img
                src={getImage(book.bookImage)}
                alt={"No Image" + book.bookTitle}
              /> */}
              {book.bookTitle}
            </div>
            <div className="details-container mt-2">
              <p className="book-title">{book.bookTitle}</p>
            </div>
            {book.isSampleBuy && (
              <div>
                <p className="bg-yellow-300 text-black">
                  This is Sample. Limited access is applied on this.
                </p>
              </div>
            )}
            <div className="details-container mt-2 mb-2">
              <div className="flex justify-center mt-2">
                <div className="tooltip-container w-20">
                  <button
                    className="ml-4 px-2 py-1 text-white rounded bg-green-500"
                    disabled={book.isCollection}
                    onClick={() =>
                      handleReadClick(
                        book.bookCode,
                        book.bookId,
                        book.bookCollectionName,
                        book.lastPageRead,
                        book.bookPages,
                        book.isChildren
                      )
                    }
                    style={{ maxWidth: "150px" }}
                  >
                    <FontAwesomeIcon icon={faBookOpen} />
                  </button>
                  <span className="tooltip">Read</span>
                </div>
                <div className="tooltip-container ml-4 w-20">
                  <button
                    className="ml-2 py-1 text-white rounded bg-green-500"
                    disabled={book.isCollection}
                    onClick={() => handleReadLogClick(book.bookId)}
                    style={{ maxWidth: "160px" }}
                  >
                    <FontAwesomeIcon icon={faBook} />
                  </button>
                  <span className="tooltip">View Read Log</span>
                </div>
              </div>
              {selectedBookId === book.bookId &&
                Object.keys(logsByDate).length > 0 &&
                book && (
                  <div className='text-lg'>
                    <div>
                      <p>
                        {book.bookTitle} has been read{" "}
                        <span className="text-green-600">
                          {readLogs.length}
                        </span>{" "}
                        times!
                      </p>
                    </div>
                    <div>
                      <p className="text-sm">Time Spent in min:sec (less than 0 seconds will be shown as 0:0)</p>
                    </div>
                    <div className="text-white bg-slate-700 flex w-full text-sm">
                      <div
                        style={{
                          width: "25%",
                          border: "1px solid white",
                          textAlign: "left",
                        }}
                      >
                        Date Read
                      </div>
                      <div style={{ width: "46%", border: "1px solid white" }}>
                        Page
                      </div>
                      <div style={{ width: "12%", border: "1px solid white" }}>
                        Time Spent
                      </div>
                      <div style={{ width: "12%", border: "1px solid white" }}>
                        Notes
                      </div>
                      <div style={{ width: "5%", border: "1px solid white" }}>
                        RCA
                      </div>
                    </div>
                    <div className="text-black bg-blue-200 w-full">
                      {Object.entries(logsByDate).map(([date, logs]) => (
                        <div key={date}>
                          <div
                            className="text-yellow-600 text-lg"
                            onClick={() => toggleDateExpansion(date)}
                            style={{ textAlign: "left" }}
                          >
                            <span>
                              {expandedDates.includes(date) ? "-" : "+"}
                            </span>{" "}
                            {formatDate(date)}
                          </div>
                          {expandedDates.includes(date) && (
                            <div>
                              {logs.map((log, index) => (
                                <div
                                  key={index}
                                  className="flex justify-start text-sm"
                                >
                                  <div
                                    style={{
                                      width: "25%",
                                      marginRight: "2px",
                                      border: "1px solid white",
                                    }}
                                  >
                                    {formatDateTime(log.dateRead)}
                                  </div>
                                  {/* <div style={{ width: "30%", marginRight: "2px", border: "1px solid white" }}>{log.pageNumber}{'. '}{log.readingRemarks}</div> */}
                                  <div
                                    style={{
                                      width: "46%",
                                      marginRight: "2px",
                                      border: "1px solid white",
                                    }}
                                  >
                                    {log.readingRemarks}
                                  </div>
                                  <div
                                    style={{
                                      width: "12%",
                                      border: "1px solid white",
                                    }}
                                  >
                                    {formatReadTime(log.readTimeInMiliseconds)}
                                  </div>
                                  <div
                                    style={{
                                      width: "12%",
                                      border: "1px solid white",
                                    }}
                                  >
                                    <Tooltip
                                      text={"Add Comment/Notes"}
                                      position={"top"}
                                    >
                                      <span
                                        className="ml-1 mr-1 text-blue-500 cursor-pointer"
                                        onClick={() =>
                                          postComment(
                                            book.bookId,
                                            book.bookTitle,
                                            book.ownerId,
                                            log.pageNumber,
                                          )
                                        }
                                      >
                                        <i className="fa-solid fa-edit"></i>
                                      </span>
                                    </Tooltip>
                                    <Tooltip
                                      text={"View Notes/Comments"}
                                      position={"top"}
                                    >
                                      <span
                                        className="ml-4 mr-4 text-blue-500 cursor-pointer"
                                        onClick={() =>
                                          handleViewComments(
                                            book.bookId,
                                            log.pageNumber,
                                            book.userId
                                          )
                                        }
                                      >
                                        <i className="fa-solid fa-comments"></i>
                                      </span>
                                    </Tooltip>
                                  </div>
                                  <div
                                    style={{
                                      width: "5%",
                                      border: "1px solid white",
                                    }}
                                  >
                                    <Tooltip
                                      text={"RCA"}
                                      position={"top"}
                                    >
                                      <span
                                        className="ml-1 mr-1 text-blue-500 cursor-pointer"
                                        onClick={() =>
                                          gotoRCA(
                                            book.bookId,
                                            book.bookTitle,
                                            book.ownerId,
                                            log.pageNumber,
                                          )
                                        }
                                      >
                                        <i className="fa-solid fa-fish"></i>
                                      </span>
                                    </Tooltip>
                                    </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                    {viewCommentClick && (
                      <div className="flex justify-center text-yellow-600 mb-4">
                        <p>{viewCommentClickMsg}</p>
                      </div>
                    )}
                  </div>
                )}

              <div>
                <p className="book-author text-blue-500">
                  Pages: {book.bookPages}
                </p>
                <p className="book-author text-blue-500">
                  Author: {book.bookAuthor}
                </p>
                <p className="book-author text-purple-700">
                  In BookShelf Since{" "}
                  <strong>{formatDateTime(book.purchaseDate)}</strong>
                </p>
                {book.isCollection === false && (
                  <>
                    <p
                      className={`book-author ${
                        book.lastReadingDate
                          ? "text-purple-700"
                          : "text-brown-500"
                      }`}
                    >
                      {book.lastReadingDate ? (
                        <>
                          Last Page Read: <strong>{book.lastPageRead}</strong>{" "}
                          On{" "}
                          <strong>
                            {formatDateTime(book.lastReadingDate)}
                          </strong>
                        </>
                      ) : (
                        <strong className="text-orange-500">
                          Not Read Yet
                        </strong>
                      )}
                    </p>
                  </>
                )}
                {book.isGifted === 1 && (
                  <div className="details-container mt-4">
                    <h2 className="text-lime-500 text-lg mb-4">
                      <FontAwesomeIcon
                        icon={faGifts}
                        className="text-red-500 text-4xl"
                      />
                    </h2>
                    <p className="text-yellow-400">
                      Gifted By : <strong>{book.gifterName}</strong>
                    </p>
                    <p className="text-purple-600">
                      <strong>{book.giftMessage}</strong>
                    </p>
                    <p className="text-green-700">{book.gifterSignatureLine}</p>
                    <p className="book-author text-blue-500">{book.gifFor}</p>
                    <p className="book-author text-gray-800">
                      Gifted on : {formatDate(book.purchaseDate)}
                    </p>
                  </div>
                )}
              </div>

              <div>
                {!book.isCollection && speechPref && (
                  <div>
                    <p>Text To Speech Preferences Before Read: </p>
                    <p>Select Language: </p>
                    <p>Set Speed: </p>
                    <p>Set Pitch: </p>
                    <p>Set Volume: </p>
                  </div>
                )}
              </div>
            </div>
            <div className="flex details-container mt-2 justify-center">
              <div className="tooltip-container w-20">
                <button
                  className="ml-2 py-1 text-white rounded bg-purple-800"
                  disabled={book.isCollection}
                  onClick={() =>
                    handleFlyOnTheWallClick(book.bookId, book.bookTitle)
                  }
                >
                  <FontAwesomeIcon icon={faUserPlus} />
                </button>
                <span className="tooltip">Allow Fly On The Wall</span>
              </div>

              <div className="tooltip-container w-20">
                <button
                  className="ml-2 py-1 text-white rounded bg-purple-800"
                  disabled={book.isCollection}
                  onClick={() =>
                    handleFlyerOnTheWallListClick(book.bookId, book.bookTitle)
                  }
                >
                  <FontAwesomeIcon icon={faUserTie} />
                </button>
                <span className="tooltip">
                  List of My Flyers On The Wall for This Book
                </span>
              </div>

              <div className="tooltip-container w-20">
                <button
                  className="py-1 text-white rounded bg-purple-800"
                  // disabled={book.isCollection}
                  disabled={true}
                  onClick={() => handleDcrClick(book.bookId, book.bookTitle)}
                >
                  <FontAwesomeIcon icon={faUserFriends} />
                </button>
                <span className="tooltip">Add Digital Co-Reader</span>
              </div>

              <div className="tooltip-container w-20">
                <button
                  className="py-1 text-white rounded bg-purple-800"
                  // disabled={book.isCollection}
                  disabled={true}
                  onClick={() =>
                    handleDcrListClick(book.bookId, book.bookTitle)
                  }
                >
                  <FontAwesomeIcon icon={faUsers} />
                </button>
                <span className="tooltip">
                  List of My Digital Co-readers for This Book
                </span>
              </div>
            </div>
            {flyOnTheWall && (
              <div className="flex justify-center">
                <Tooltip text={"Allow Fly On The Wall"} position={"top"}>
                  <button
                    className="ml-2 py-1 text-white rounded bg-orange-500"
                    disabled={false}
                    style={{ maxWidth: "160px" }}
                  >
                    <FontAwesomeIcon icon={faUserPlus} />
                    {/* Allow Fly On The Wall */}
                  </button>
                </Tooltip>
                {/* <div className="tooltip-container w-20">
                                    <button
                                        className="py-1 text-white rounded bg-purple-800"
                                        onClick={() => handleDcrListClick(book.bookId, book.bookTitle)}
                                    >
                                        <FontAwesomeIcon icon={faUserPlus} />
                                    </button>
                                    <span className="tooltip">Allow Fly On The Wall</span>
                                </div> */}
                <Tooltip
                  text={" Who All Are Flying On The Wall?!"}
                  position={"top"}
                >
                  <button
                    className="ml-2 py-1 text-white rounded bg-orange-500"
                    disabled={false}
                    style={{ maxWidth: "200px" }}
                  >
                    <FontAwesomeIcon icon={faUserTie} />
                    {/* Who All Are Flying On The Wall?! */}
                  </button>
                </Tooltip>
                {/* <div className="tooltip-container w-20">
                                    <button
                                        className="py-1 text-white rounded bg-purple-800"
                                        onClick={() => handleDcrListClick(book.bookId, book.bookTitle)}
                                    >
                                        <FontAwesomeIcon icon={faUserTie} />
                                    </button>
                                    <span className="tooltip">Who All Are Flying On The Wall?!</span>
                                </div> */}
              </div>
            )}
            {book.buyingMethod === "MLM" && (
              <div>
                <div>
                  <div>
                    <p className="text-lg text-purple-700">
                      You are eligible for Multi Level Referral program. Under
                      this program you can earn active & passive income as per
                      following chart:{" "}
                    </p>
                  </div>
                  <div>
                    <button
                      className="py-1 text-white rounded bg-blue-700"
                      onClick={() => setShowTable(!showTable)}
                    >
                      Click here to see Multi-Level referral income chart
                    </button>
                    {showTable && <MultiLevelReferralTable />}
                  </div>
                </div>
                <div className="flex justify-center">
                  <p className="text-lg text-green-600">
                    My Referrer:{" "}
                    <strong className="text-lg">{book.advisorName}</strong>
                  </p>
                </div>
                <div className="mt-2 justify-center">
                  <button
                    className="py-1 text-white rounded bg-purple-700"
                    onClick={() => {
                      handleMyReferralsListClick(
                        book.bookId,
                        book.userCode,
                        book.userLevel
                      );
                      toggleReferralsList();
                    }}
                  >
                    {showReferrals 
                      ? "Hide Referrals List"
                      : "Show Referrals List"}
                  </button>
                  {/* {selectedBookId}{' data book '}{} */}
                  {showReferrals && (
                    <div>
                      {myReferralsList.length === 0 && selectedBookId === book.bookId ? (
                        <p className="text-red-500">
                          There is No Referral Sales Yet for the book {book.bookTitle}!!
                        </p>
                      ) : (
                        myReferralsList.map((referral, index) => (
                          <>
                          {/* <div><p>Referral List for {book.bookTitle}</p></div> */}
                          <div
                            key={index}
                            className="bg-gray-300 border-b text-blue-500 ml-4 mr-4 mb-1"
                          >
                            {/* <p className='text-blue-500'>SN: {index + 1}</p> */}
                            <p className="text-blue-500">
                              {index + 1}. User: {referral.userName} (
                              {referral.userCode})
                            </p>
                            {/* <p className='text-blue-500'>User Code: {referral.userCode}</p> */}
                            <p className="text-blue-500">
                              Purchase Date:{" "}
                              {new Date(
                                referral.purchaseDate
                              ).toLocaleDateString()}
                            </p>
                            <p className="text-blue-500">
                              Purchase Price: {referral.salesPrice.toFixed(2)}
                            </p>
                            {/* <p className='text-blue-500'>Level: {referral.userLevel}</p> */}
                          </div>
                          </>
                        ))
                      )}
                    </div>
                  )}
                </div>

                {/* <>
                  <MLMButtonWithCount
                    buttonText="Show Lifetime Count"
                    handleClick={() =>
                      handleDownTheLineGetAllCount(book.bookId)
                    }
                    isClicked={downTheLineGetAllCountClicked}
                    data={downTheLineGetCount}
                  />
                  <MLMButtonWithCount
                    buttonText="Show Today's Count"
                    handleClick={() =>
                      handleDownTheLineGetTodayCount(book.bookId)
                    }
                    isClicked={downTheLineGetTodayCountClicked}
                    data={downTheLineGetCount}
                  />
                  <MLMButtonWithCount
                    buttonText="Show This Week Count"
                    handleClick={() =>
                      handleDownTheLineGetLastSevenDaysCount(book.bookId)
                    }
                    isClicked={downTheLineGetLastSevenDaysCountClicked}
                    data={downTheLineGetCount}
                  />
                  <MLMButtonWithCount
                    buttonText="Show MTD (Month Till Date) Count"
                    handleClick={() =>
                      handleDownTheLineGetMTDCount(book.bookId)
                    }
                    isClicked={downTheLineGetMTDCountClicked}
                    data={downTheLineGetCount}
                  />
                  <MLMButtonWithCount
                    buttonText="Show YTD (Year Till Date) Count"
                    handleClick={() =>
                      handleDownTheLineGetYTDCount(book.bookId)
                    }
                    isClicked={downTheLineGetYTDCountClicked}
                    data={downTheLineGetCount}
                  />
                  <MLMButtonWithCount
                    buttonText="Show Count For A Start to End Date"
                    handleClick={() =>
                      handleDownTheLineGetCustomCount(book.bookId)
                    }
                    isClicked={downTheLineGetCustomCountClicked}
                    data={downTheLineGetCount}
                  />
                </> */}
                {/* <div className='mt-2 justify-center'>
                                <p className='text-xl text-blue-600 mb-2'>My Down-the-lines Referrals Count</p>
                            </div> */}

                <div className="mt-2 justify-center">
                  <button
                    className="py-1 text-white rounded bg-orange-500"
                    onClick={() => handleDownTheLineGetAllCount(book.bookId)}
                    disabled={downTheLineGetAllCountClicked}
                  >
                    Show Lifetime Count
                  </button>
                  {downTheLineGetAllCountClicked && downTheLineGetCount && (
                    <div className="book-list-container ml-8 mt-2 text-red-800 overflow-x-auto">
                      <div className="overflow-x-auto">
                        <table className="responsive-table">
                          <thead className="bg-gray-800">
                            <tr>
                              <th className="py-3 px-4 uppercase font-semibold text-sm">
                                Level
                              </th>
                              <th className="py-3 px-4 uppercase font-semibold text-sm">
                                Members
                              </th>
                              <th className="py-3 px-4 uppercase font-semibold text-sm">
                                Commission
                              </th>
                            </tr>
                          </thead>
                          <tbody className="text-gray-700">
                            <tr>
                              <td className="py-3 px-4">Level 1</td>
                              <td className="py-3 px-4">
                                {downTheLineGetCount.l1.count}
                              </td>
                              <td className="py-3 px-4">
                                {parseFloat(
                                  downTheLineGetCount.l1.totalCom
                                ).toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td className="py-3 px-4">Level 2</td>
                              <td className="py-3 px-4">
                                {downTheLineGetCount.l2.count}
                              </td>
                              <td className="py-3 px-4">
                                {parseFloat(
                                  downTheLineGetCount.l2.totalCom
                                ).toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td className="py-3 px-4">Level 3</td>
                              <td className="py-3 px-4">
                                {downTheLineGetCount.l3.count}
                              </td>
                              <td className="py-3 px-4">
                                {parseFloat(
                                  downTheLineGetCount.l3.totalCom
                                ).toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td className="py-3 px-4">Level 4</td>
                              <td className="py-3 px-4">
                                {downTheLineGetCount.l4.count}
                              </td>
                              <td className="py-3 px-4">
                                {parseFloat(
                                  downTheLineGetCount.l4.totalCom
                                ).toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td className="py-3 px-4">Level 5</td>
                              <td className="py-3 px-4">
                                {downTheLineGetCount.l5.count}
                              </td>
                              <td className="py-3 px-4">
                                {parseFloat(
                                  downTheLineGetCount.l5.totalCom
                                ).toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td className="py-3 px-4">Level 6</td>
                              <td className="py-3 px-4">
                                {downTheLineGetCount.l6.count}
                              </td>
                              <td className="py-3 px-4">
                                {parseFloat(
                                  downTheLineGetCount.l6.totalCom
                                ).toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td className="py-3 px-4">Level 7</td>
                              <td className="py-3 px-4">
                                {downTheLineGetCount.l7.count}
                              </td>
                              <td className="py-3 px-4">
                                {parseFloat(
                                  downTheLineGetCount.l7.totalCom
                                ).toFixed(2)}
                              </td>
                            </tr>
                            <tr>
                              <td className="py-3 px-4">Level 8</td>
                              <td className="py-3 px-4">
                                {downTheLineGetCount.l8.count}
                              </td>
                              <td className="py-3 px-4">
                                {parseFloat(
                                  downTheLineGetCount.l8.totalCom
                                ).toFixed(2)}
                              </td>
                            </tr>
                            <tr className="bg-yellow-600">
                              <td className="py-3 px-4 font-semibold">Total</td>
                              <td className="py-3 px-4 font-semibold">
                                {totalCount}
                              </td>
                              <td className="py-3 px-4 font-semibold">
                                {totalCommission.toFixed(2)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
                <div className="mt-2 justify-center">
                  <button
                    className="py-1 text-white rounded bg-orange-500"
                    onClick={() => handleDownTheLineGetTodayCount(book.bookId)}
                    disabled={downTheLineGetTodayCountClicked}
                  >
                    Show Today's Count
                  </button>
                  {downTheLineGetTodayCountClicked && downTheLineGetCount && (
                    <div className="mt-4">
                      <p>
                        Level 1: {downTheLineGetCount.l1.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l1.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 2: {downTheLineGetCount.l2.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l2.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 3: {downTheLineGetCount.l3.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l3.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 4: {downTheLineGetCount.l4.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l4.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 5: {downTheLineGetCount.l5.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l5.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 6: {downTheLineGetCount.l6.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l6.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 7: {downTheLineGetCount.l7.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l7.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 8: {downTheLineGetCount.l8.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l8.totalCom).toFixed(2)}
                      </p>
                    </div>
                  )}
                </div>
                <div className="mt-2 justify-center">
                  <button
                    className="py-1 text-white rounded bg-orange-500"
                    onClick={() =>
                      handleDownTheLineGetLastSevenDaysCount(book.bookId)
                    }
                    disabled={true}
                  >
                    Show This Week Count
                  </button>
                  {downTheLineGetLastSevenDaysCountClicked &&
                    downTheLineGetCount && (
                      <div className="mt-4">
                        <p>
                          Level 1: {downTheLineGetCount.l1.count} members, Total
                          Commission:{" "}
                          {parseFloat(downTheLineGetCount.l1.totalCom).toFixed(
                            2
                          )}
                        </p>
                        <p>
                          Level 2: {downTheLineGetCount.l2.count} members, Total
                          Commission:{" "}
                          {parseFloat(downTheLineGetCount.l2.totalCom).toFixed(
                            2
                          )}
                        </p>
                        <p>
                          Level 3: {downTheLineGetCount.l3.count} members, Total
                          Commission:{" "}
                          {parseFloat(downTheLineGetCount.l3.totalCom).toFixed(
                            2
                          )}
                        </p>
                        <p>
                          Level 4: {downTheLineGetCount.l4.count} members, Total
                          Commission:{" "}
                          {parseFloat(downTheLineGetCount.l4.totalCom).toFixed(
                            2
                          )}
                        </p>
                        <p>
                          Level 5: {downTheLineGetCount.l5.count} members, Total
                          Commission:{" "}
                          {parseFloat(downTheLineGetCount.l5.totalCom).toFixed(
                            2
                          )}
                        </p>
                        <p>
                          Level 6: {downTheLineGetCount.l6.count} members, Total
                          Commission:{" "}
                          {parseFloat(downTheLineGetCount.l6.totalCom).toFixed(
                            2
                          )}
                        </p>
                        <p>
                          Level 7: {downTheLineGetCount.l7.count} members, Total
                          Commission:{" "}
                          {parseFloat(downTheLineGetCount.l7.totalCom).toFixed(
                            2
                          )}
                        </p>
                        <p>
                          Level 8: {downTheLineGetCount.l8.count} members, Total
                          Commission:{" "}
                          {parseFloat(downTheLineGetCount.l8.totalCom).toFixed(
                            2
                          )}
                        </p>
                      </div>
                    )}
                </div>
                <div className="mt-2 justify-center">
                  <button
                    className="py-1 text-white rounded bg-orange-500"
                    onClick={() => handleDownTheLineGetMTDCount(book.bookId)}
                    disabled={true}
                  >
                    Show MTD (Month Till Date) Count
                  </button>
                  {downTheLineGetMTDCountClicked && downTheLineGetCount && (
                    <div className="mt-4">
                      <p>
                        Level 1: {downTheLineGetCount.l1.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l1.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 2: {downTheLineGetCount.l2.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l2.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 3: {downTheLineGetCount.l3.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l3.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 4: {downTheLineGetCount.l4.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l4.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 5: {downTheLineGetCount.l5.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l5.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 6: {downTheLineGetCount.l6.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l6.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 7: {downTheLineGetCount.l7.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l7.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 8: {downTheLineGetCount.l8.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l8.totalCom).toFixed(2)}
                      </p>
                    </div>
                  )}
                </div>
                <div className="mt-2 justify-center">
                  <button
                    className="py-1 text-white rounded bg-orange-500"
                    onClick={() => handleDownTheLineGetYTDCount(book.bookId)}
                    disabled={true}
                  >
                    Show YTD (Year Till Date) Count
                  </button>
                  {downTheLineGetYTDCountClicked && downTheLineGetCount && (
                    <div className="mt-4">
                      <p>
                        Level 1: {downTheLineGetCount.l1.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l1.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 2: {downTheLineGetCount.l2.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l2.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 3: {downTheLineGetCount.l3.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l3.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 4: {downTheLineGetCount.l4.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l4.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 5: {downTheLineGetCount.l5.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l5.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 6: {downTheLineGetCount.l6.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l6.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 7: {downTheLineGetCount.l7.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l7.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 8: {downTheLineGetCount.l8.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l8.totalCom).toFixed(2)}
                      </p>
                    </div>
                  )}
                </div>
                <div className="mt-2 justify-center">
                  <button
                    className="py-1 text-white rounded bg-orange-500"
                    onClick={() => handleDownTheLineGetCustomCount(book.bookId)}
                    disabled={true}
                  >
                    Show Count For A Start to End Date
                  </button>
                  {downTheLineGetCustomCountClicked && downTheLineGetCount && (
                    <div className="mt-4">
                      <p>
                        Level 1: {downTheLineGetCount.l1.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l1.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 2: {downTheLineGetCount.l2.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l2.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 3: {downTheLineGetCount.l3.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l3.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 4: {downTheLineGetCount.l4.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l4.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 5: {downTheLineGetCount.l5.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l5.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 6: {downTheLineGetCount.l6.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l6.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 7: {downTheLineGetCount.l7.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l7.totalCom).toFixed(2)}
                      </p>
                      <p>
                        Level 8: {downTheLineGetCount.l8.count} members, Total
                        Commission:{" "}
                        {parseFloat(downTheLineGetCount.l8.totalCom).toFixed(2)}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    );
};

export default BookShelfListComponent;
